import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../../components/ui/button/button";
import { useLang } from "../../../../hooks";

export default function Nodata({ type }) {
  // Translations
  const { t } = useTranslation();
  const lang = useLang();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "24px",
        padding: "72px 20px 130px 20px"
      }}
    >
      <img
        src="/images/icons/order/no-data.svg"
        width={80}
        height={93}
        alt="Availability in 20 countries"
        loading="lazy"
      />

      {t("cabinet.orders.noData")}
      <Button
        variant="primary"
        onClick={() => navigate(`/${lang}/cabinet/new-order/?newOrderProxy=${type}`)}
      >
        {t("form.actions.buyProxy")}
      </Button>
    </Box>
  );
}
